module.exports = __webpack_public_path__ + "img/348.60e27568.jpg";